import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';


export interface OptionsRelatorio {
  text: string;
  value: any;
  cssClass: string;
  icon?: string;
  active: boolean;
  type?: string | 'print' | 'pdf' | 'xls' | 'csv';
}

@Component({
  selector: 'app-impressao',
  templateUrl: './impressao.component.html',
  styleUrls: ['./impressao.component.scss']
})
export class ImpressaoComponent {

  options: OptionsRelatorio[] = [
    { text: 'Cancelar', value: true, cssClass: 'btn-link btn-sm', active: true },
    { text: 'Baixar PDF', value: true, cssClass: 'btn-link btn-sm', active: true, icon: 'mr-1 icon-pdf', type: 'pdf' },
    { text: 'Imprimir', value: true, cssClass: 'btn-dark btn-sm', active: true, icon: 'mr-1 icon-printer', type: 'print' }
  ];
  title: string;
  message: string;

  constructor(public activeModal: NgbActiveModal) { }


  setMessage(message: string | Array<string>) {
    const messageMerge = message instanceof Array ? message.join('<br>') : message;
    this.message = messageMerge;
  }

  action(type) {
    switch (type) {
      case 'print':
        alert('print')
        break;
      case 'pdf':
        alert('pdf')
        break;
      case 'xls':
        alert('xls')
        break;
      case 'csv':
        alert('csv')
        break;
      default:
        alert('close')
        this.activeModal.close('close');
        break;
    }
  }
}
